import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import { Dialog } from "primereact/dialog";
import _ from "lodash";

import "../index.css"

import { DropDownField } from "../../../../helpers";

import CopyToClipboard from "../../../../common/CopyToClipboard";

import BuyerPOModalData from "./BuyerPoModalData";

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";
import { getBuyerPOItemsByBuyerPOIds } from "../../../../services/api/buyerPOItem";
import { getDateString } from "../../../../utils";
import { deleteBuyerPO } from "../../../../services/redux/reducers/Requirement/requirement";
import { setSelectedBuyerQuoteId } from "../../../../services/redux/reducers/buyerDashboard/buyerDashboardRequirement";
import { getApprovalInstancesByDocNos } from "../../../../services/api/approvalInstances";
import { fetchApprovalTypes, fetchApprovals } from "../../../../services/redux/reducers/commonThunk";


const BuyerPoModalData = (props) => {
    const { selectedReq, buyerQuotes, sellerPOs, setVisibleBuyerpo, visibleBuyerpo } = props

    const [isLoading, setIsLoading] = useState(false)
    const [approvalInstances, setApprovalInstances] = useState([])
    const [relatedBuyerQuotes, setRelatedBuyerQuotes] = useState([])
    const [buyerPOs, setBuyerPO] = useState([])
    const [buyerPOItems, setBuyerPOItems] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])

    const approvals = useSelector(state => state.common.approvals)
    const approvalTypes = useSelector((state) => state.common.approvalTypes)

    const selectedBuyerQuoteId = useSelector(state => state.requirementDashboard.selectedBuyerQuoteId)
    const dispatch = useDispatch()
    const buyerPOData = useSelector(state => state.requirementDashboard.buyerPOData)

    useEffect(() => {
        dispatch(fetchApprovals())
        dispatch(fetchApprovalTypes())
    }, [])

    useEffect(() => {
        return () => {
            dispatch(setSelectedBuyerQuoteId(null))
        }
    }, [])

    useEffect(() => {
        setIsLoading(false)
        let activeBuyerQuotesData = buyerQuotes?.filter(eachBuyerQuote => eachBuyerQuote?.buyerReqId === selectedReq?.buyerReqId && eachBuyerQuote?.statusId === 1)
        // let activeBuyerQuotesData = activeBuyerQuotesData?.filter(eachBuyerQuote => eachBuyerQuote?.statusId === 1)
        activeBuyerQuotesData = activeBuyerQuotesData?.map(eachBuyerQuote => {
            let createdAtString = getDateString(eachBuyerQuote?.createdAt)
            return { ...eachBuyerQuote, docNo: `${eachBuyerQuote?.docNo} (${createdAtString})` }
        })
        activeBuyerQuotesData = _.sortBy(activeBuyerQuotesData, "createdAt")
        if (activeBuyerQuotesData?.length > 1) {
            setRelatedBuyerQuotes(activeBuyerQuotesData)
            setBuyerPO([])
            setBuyerPOItems([])
        } else {
            setRelatedBuyerQuotes(activeBuyerQuotesData)
            dispatch(setSelectedBuyerQuoteId(activeBuyerQuotesData?.[0]?.buyerQuoteId))
        }

    }, [selectedReq])

    useEffect(() => {
        getBuyerPO()
    }, [buyerPOData, selectedBuyerQuoteId])

    const getBuyerPO = async () => {
        if (selectedBuyerQuoteId) {
            setIsLoading(true)
            const relatedBuyerPOs = props.buyerPOs?.filter(eachBuyerPO => parseInt(eachBuyerPO?.buyerQuoteId) === selectedBuyerQuoteId)
            
            const buyerPOIds = relatedBuyerPOs?.map(eachBuyerPO => eachBuyerPO?.buyerPOId)
            const docNos = relatedBuyerPOs?.map(eachBuyerPO => eachBuyerPO.docNo)
            let relatedBuyerPOItemsData = []

            if (buyerPOIds.length > 0) {
                const buyerPOItemsRes = await getBuyerPOItemsByBuyerPOIds(buyerPOIds)
                if (buyerPOItemsRes?.failure) {
                    return dispatch(raiseToast({ severity: 'error', summary: "Buyer PO Items", detail: buyerPOItemsRes?.data?.error, life: 3000 }))
                } else {
                    relatedBuyerPOItemsData = buyerPOItemsRes.data
                }

                const approvalInstanceRes = await getApprovalInstancesByDocNos({docNos: docNos})

                if (approvalInstanceRes.failure) {
                    return dispatch(raiseToast({ severity: 'error', detail: approvalInstanceRes?.data?.error }))
                }
                setApprovalInstances(approvalInstanceRes.data)
            }

            setBuyerPO(relatedBuyerPOs)
            setBuyerPOItems(relatedBuyerPOItemsData)
            setMaterialDetails(props?.materialDetails)
            setIsLoading(false)
        } else {
            setBuyerPO([])
            setBuyerPOItems([])
        }
    }

    const handleDeleteClick = async (data) => {
        const updatedBuyerPOList = buyerPOData.buyerPOs.map((eachBuyerPO) => {
            if (eachBuyerPO.buyerPOId === data.updatedBuyerPO.buyerPOId) {
                return {
                    ...eachBuyerPO,
                    statusId: data.updatedBuyerPO.statusId
                }
            }
            return eachBuyerPO
        })
        const updatedBuyerPOData = { ...buyerPOData, buyerPOs: [...updatedBuyerPOList] }
        dispatch(deleteBuyerPO(updatedBuyerPOData))

        dispatch(raiseToast({ severity: 'warn',  detail: "Buyer PO deleted successfully", life: 3000 }))

        getBuyerPO()
    }

    const handleOnHideDialog = () => {
        dispatch(setSelectedBuyerQuoteId(null))
        setBuyerPO([])
        setVisibleBuyerpo(false)
    }

    const handleApprovalRequest = (data) => {
        setApprovalInstances([...approvalInstances, data])
    }

    const renderHeader = () => {
        return (
            <div className="flex flex-row justify-content-between">
                <p>PURCHASE ORDER</p>
                <div className="col-5 flex flex-row justify-content-end align-items-center py-0">
                    <span style={{ fontSize: "13px", marginRight: "5px" }} >Quote No: </span>
                    <span className=""><DropDownField options={relatedBuyerQuotes} className="document-select-dropdown" optionLabel="docNo" optionValue="buyerQuoteId" value={selectedBuyerQuoteId} onChange={(e) => { dispatch(setSelectedBuyerQuoteId(e.target.value)) }} /></span>
                </div>
            </div>
        )
    }


    let buyerName = ""
    if (selectedReq["buyer.firstName"]) {
        buyerName = selectedReq["buyer.firstName"]
    }
    if (selectedReq["buyer.lastName"]) {
        buyerName += " " + selectedReq["buyer.lastName"]
    }

    return (
        <Dialog header={renderHeader} headerClassName="pb-0" className="buyerpo-dialog buyper-buyerpo-modal" visible={visibleBuyerpo} style={{ width: '90vw', height: '80vh' }} onHide={handleOnHideDialog}>
            <div className="buyerpo-modal buyer-po-modal">
                {/*<div className="col-12 md:col-2 lg:col-2">
                    <DropDownField options={relatedBuyerQuotes} labelText="Buyer Quote No" optionLabel="docNo" optionValue="buyerQuoteId" value={selectedBuyerQuoteId} onChange={(e) => {dispatch(setSelectedBuyerQuoteId(e.target.value))}}/>
                </div>*/}
                {selectedReq ?
                    <p className="m-0">
                        <span style={{ fontWeight: "bold" }}> Requirement No: </span><span className="ml-1 req-no">{selectedReq["docNo"]} <CopyToClipboard text={selectedReq["docNo"]} /></span>
                        {/* <span className="ml-5" style={{ fontWeight: "bold" }}> Buyer: </span> {selectedReq["company.companyName"]} - {selectedReq["buyerCompanyBranch.branchName"]} - {buyerName} */}
                    </p>
                    : ""
                }
                {
                    !selectedBuyerQuoteId &&
                    <div className="flex justify-content-center">
                        <p className="font-bold">Please select the Buyer Quote No.</p>
                    </div>
                }
                {
                    isLoading ?
                        (
                            <div className="flex justify-content-center h-full">
                                <ThreeDots height="50" width="50" radius="5" color="#00baac" ariaLabel="three-dots-loading" visible={isLoading} />
                            </div>
                        ) : (
                            <>
                                {
                                    buyerPOs?.length === 0 && selectedBuyerQuoteId ? (
                                        <div className="flex justify-content-center">
                                            <p className="font-bold">Buyer pos has not found for the selected buyer quote.</p>
                                        </div>
                                    ) : (
                                        buyerPOs?.map(eachBuyerPO => {
                                            const relatedBuyerPOItems = buyerPOItems?.filter(eachBuyerPOItem => eachBuyerPOItem?.buyerPOId === eachBuyerPO?.buyerPOId)
                                            const relatedApprovalInstances = approvalInstances.filter(eachApprovalInstance => eachApprovalInstance.docNo === eachBuyerPO.docNo)
                                            const relatedBuyerQuote = buyerQuotes.find(eachBuyerQuote => eachBuyerQuote.buyerQuoteId === eachBuyerPO.buyerQuoteId)
                                            return (
                                                <BuyerPOModalData 
                                                    key={`buyerPO-${eachBuyerPO.buyerPOId}`}
                                                    buyerPO={eachBuyerPO} 
                                                    sellerPOs={sellerPOs} 
                                                    buyerPOItems={relatedBuyerPOItems} 
                                                    materialDetails={materialDetails} 
                                                    handleDeleteClick={handleDeleteClick} 
                                                    approvalInstances={relatedApprovalInstances} 
                                                    buyerReq={selectedReq}
                                                    approvals={approvals}
                                                    approvalTypes={approvalTypes}
                                                    buyerQuote={[relatedBuyerQuote]}
                                                    handleApprovalRequest={handleApprovalRequest}
                                                />
                                            )
                                        })
                                    )
                                }
                            </>
                        )
                }
            </div>
        </Dialog>
    )
}

export default BuyerPoModalData;